module.exports = __webpack_public_path__ + "static/EM1-8ab6e15ae34425f88628f6910d9e8693.jpg";